// the keys here should match those in constants/pageTypes.js
//
// key: internal page type; value: GA page type
export const GA_PAGE_TYPES = {
  author: 'Author Index',
  archive: 'Archive Index',
  category: 'Category Index (née Vertical Index)',
  collection: 'Tag Index (née Category Index)',
  feature: 'Feature Page',
  home: 'Home Page',
  homemade: 'Homemade',
  page: 'Standalone Page',
  post: 'Post Page',
  error404: '404 Page',
  error: 'Error Page',
  preview: 'Preview Page',
  email: 'Email Page',
  search: 'Site Search',
  account: 'My Account',
  savedStories: 'My Account: Saved Stories',
  visionBoards: 'My Account: Vision Boards',
  visionBoard: 'My Account: Vision Board',
  prismImage: 'Prism Image Page',
  prismTag: 'Prism Tag Page',
  prismColor: 'Prism Color Page',
  authentication: 'Not Authorized Page',
  essentialProducts: 'Essential Products Page',
  faq: 'FAQ Page',
  contest: 'Contest Page',
  submission: 'Submission Page',
  staticPrismPage: 'Prism Landing Page',
  smallCoolExperience: 'Small Cool Experience',
  imageCollection: 'Image Collections Page',
  recipeBox: 'Recipe Box'
};

/**
 * when passed an internal page type, returns a GA-specific page type. defaults
 * to 'Not Set' for unknown page types.
 *
 * @export
 * @param {String} [pageType=''] internal page type
 * @returns page type for GA reporting
 */
export function getGaPageType(pageType = '') {
  return GA_PAGE_TYPES[pageType] || 'Not Set';
}
